import { render, staticRenderFns } from "./AddOrUpdateEarlyWarning.vue?vue&type=template&id=1a0db5b9&scoped=true&"
import script from "./AddOrUpdateEarlyWarning.vue?vue&type=script&lang=ts&"
export * from "./AddOrUpdateEarlyWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0db5b9",
  null
  
)

export default component.exports